import React from "react";

import { SidebarItemsType } from "../../types/sidebar";
import SidebarNavList from "./SidebarNavList";

type SidebarNavSectionProps = {
  className?: Element;
  component?: React.ElementType;
  pages: SidebarItemsType[];
  title?: string;
  collapsed?: boolean;
};

const SidebarNavSection: React.FC<SidebarNavSectionProps> = (props) => {
  const {
    pages,
    component: Component = "nav",
    collapsed = false,
    ...rest
  } = props;

  return (
    <Component {...rest}>
      <SidebarNavList pages={pages} depth={0} collapsed={collapsed} />
    </Component>
  );
};

export default SidebarNavSection;
